import { useMutation } from "@tanstack/react-query";
import { orpc } from "@/frontend/orpc-client";

export function useGetAppDeepLinkMutation() {
  return useMutation(
    orpc.onboarding.getAppDeepLink.mutationOptions({
      onSuccess: (data) => {
        if (data?.deepLink) {
          window.location.href = data.deepLink;
        }
      },
    })
  );
}
